export default __webpack_public_path__ + "static/media/img6.62aa00f1.jpg";